import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-11a0c685"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["src"];
const _hoisted_2 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass($props.text == '悬浮图片' ? 'suspensionAssembly' : 'suspensionAssemblys'),
    onClick: _cache[0] || (_cache[0] = $event => $options.openpage(_ctx.item))
  }, [_createElementVNode("div", {
    class: "relative",
    style: _normalizeStyle({
      'margin-top': $props.content.topMargin + 'px',
      'padding-left': $props.content.leftMargin + 'px',
      'padding-right': $props.content.rightMargin + 'px',
      'margin-bottom': $props.content.bottomMargin + 'px',
      left: $data.clleft + 'px',
      top: $data.cltop,
      height: $data.height + 'px',
      'position': $props.text == '悬浮图片' ? 'fixed' : 'absolute'
    })
  }, [this.text === '品牌logo' ? (_openBlock(), _createElementBlock("img", {
    key: 0,
    class: "img",
    src: $data.popimgs,
    style: _normalizeStyle({
      width: $data.width + 'px'
    })
  }, null, 12, _hoisted_1)) : (_openBlock(), _createElementBlock("img", {
    key: 1,
    class: "img",
    src: $props.content.popimg,
    style: _normalizeStyle({
      width: $data.width + 'px'
    })
  }, null, 12, _hoisted_2))], 4)], 2);
}